export default __webpack_public_path__ + "static/media/personal.3f8273dc.jpg";